import Tasks from 'APP/Tasks';
import { IStickerPackExtend } from 'APP/model/stickers/stickersModel.types';
import { storage } from 'APP/packages/storage';
import Entities from 'STORE';

// TODO: add typings
export function handleMyStickers({ updateTs }: { updateTs: number }): void {
  const data = storage.installedStickerPacks.get();

  if (data === null || !data.lastUpdateTime || updateTs !== data.lastUpdateTime) {
    Tasks.stickers.loadUserInstalledStickerPacks(updateTs);
    return;
  }

  const packs = Object.values(data.packs).map((pack: IStickerPackExtend) => {
    pack.stickerPack.id = pack.stickerPack.id.toString();
    return pack;
  });

  Entities.stickersStore.mergePacks(packs);
  Entities.stickersStore.setInstalledPackIds(packs.map(({ stickerPack }) => stickerPack.id));
}
